import type { ReactNode } from 'react';

/** Shared chrome for the sign-in page and the Microsoft OAuth callback page,
 * so a mid-redirect page doesn't look like a different app (R-306). */
export function AuthLayout({ children, footer }: { children: ReactNode; footer?: ReactNode }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100dvh',
        padding: 'var(--space-6)',
        background: 'var(--color-bg)',
      }}
    >
      <div style={{ width: '100%', maxWidth: '400px' }}>
        {/* Brand */}
        <div style={{ textAlign: 'center', marginBottom: 'var(--space-8)' }}>
          <h1
            style={{
              fontSize: '2rem',
              fontWeight: 800,
              color: 'var(--color-accent)',
              letterSpacing: '-0.03em',
            }}
          >
            Anchor
          </h1>
          <p style={{ color: 'var(--color-text-muted)', marginTop: 'var(--space-1)' }}>
            Admin console
          </p>
        </div>

        <div className="card">{children}</div>

        {footer}
      </div>
    </div>
  );
}
